import apiFetch from '../apiFetch'

export default function (listadoAnadir, token) {
  return apiFetch({endPoint: `GrupoVerraco/getAnadirVerracos`, method: 'POST', body: listadoAnadir, token: token})
}